import { Action } from './type'

export type ColumnAction = Action & {
  type:
    | 'TOGGLE_COLUMN'
    | 'UPDATE_COLUMNS'
    | 'CLEAR_ALL'
    | 'RESET'
    | 'ADD_CONDITION'
}

export const TOGGLE_COLUMN = 'TOGGLE_COLUMN'
export function toggleColumn(name: string) {
  return { type: TOGGLE_COLUMN, payload: name }
}

export const UPDATE_COLUMNS = 'UPDATE_COLUMNS'
export const updateColumns = (names: string[]) => ({
  type: UPDATE_COLUMNS,
  payload: names,
})

export const CLEAR_ALL = 'CLEAR_ALL'
export function clearAll() {
  return { type: CLEAR_ALL }
}

export const RESET = 'RESET'
export function reset(initialColumnNames: string[]) {
  return { type: RESET, payload: initialColumnNames }
}
